/* import __COLOCATED_TEMPLATE__ from './phone-number.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PhoneFormatter, TextField } from 'field-kit';
import { inject as service } from '@ember/service';
import { select } from '@banking/ui/services/investments-workflow';
import { userChangePhoneNumberAction, userClickEnrollAction } from '@banking/ui/workflows/investments';
let PhoneNumber = (_dec = select(state => state.phoneNumber), _dec2 = select(state => state.phoneNumberError), _dec3 = select(state => state.phoneNumberError?.length > 0), _dec4 = select(state => state.toggleButtonLoading), (_class = class PhoneNumber extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor2, this);
    _initializerDefineProperty(this, "phoneNumberError", _descriptor3, this);
    _initializerDefineProperty(this, "hasPhoneNumberError", _descriptor4, this);
    _initializerDefineProperty(this, "isButtonLoading", _descriptor5, this);
  }
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new PhoneFormatter();
    if (this.phoneNumber) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.phoneNumber);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => this.investmentsWorkflow.emit(userChangePhoneNumberAction(field.value()));
    fieldKit.setDelegate({
      textDidChange
    });
  }
  onNextButtonClick() {
    // TODO(@tianbi) implement this method
    this.investmentsWorkflow.emit(userClickEnrollAction());
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberError", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasPhoneNumberError", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isButtonLoading", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNextButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onNextButtonClick"), _class.prototype)), _class));
export { PhoneNumber as default };